<template>
    <div class="ReportIndex">
        <Banner></Banner>
        <!-- banner end  -->
       <section class="bg-down">
           <div class="page-module">
            <header class="index-head">
                <p class="name">报告下载</p>
                <p class="msg">共124个细分行业</p>
                <p class="more" @click="routerSearch('','')">更多 ></p>
            </header>
            <div class="content">
                <div v-for="(item,index) in bgDownData" :key="index" @click="routerSearch(item.code, item.code2)">
                    <img :src="item.img" :alt="item.name">
                    <p>{{item.name}}</p>
                </div>
            </div>
           </div>
       </section>
       <!-- 报告下载 end -->
        
        <div class="page-module" style="padding-bottom: 30px">
            <NewBg :newreportlist="newreportlist"></NewBg>
            <!-- 最新报告 end -->

            <BestSellerList :sellwelllist="sellwelllist"></BestSellerList>
            <!-- 畅销榜单 end  -->
        </div>
        <!-- 最新报告 & 畅销榜单 end -->

        <PanicBuying :limitedtimelist="limitedtimelist"></PanicBuying>
        <!-- 抢购 end  -->

        <section class="advertisement page-module" @click="routeAdvertisement(advertisement1.clickurl)"><img v-lazy="advertisement1.adurl" :alt="advertisement1.adtitle">
        </section>
        <!-- 广告 end -->
        
        <Recommend :list="hotreportlist" :type="'host'"></Recommend>
        <!-- 热门推荐 end -->

        <section class="advertisement page-module" @click="routeAdvertisement(advertisement2.clickurl)"><img v-lazy="advertisement2.adurl" :alt="advertisement2.adtitle">
        </section>
        <!-- 广告 end -->

        <Recommend :list="freereportlist" :type="'free'"></Recommend>
        <!-- 免费报告 end -->

        <Love :everyonelikelist="everyonelikelist"></Love>
        <!-- 大家都爱看 end -->

    </div>
</template>

<script>
import Banner from './components/Banner'
import NewBg from './components/NewBg'
import BestSellerList from './components/BestSellerList'
import PanicBuying from './components/PanicBuying'
import Recommend from './components/Recommend'
import Love from './components/Love'
import {getIndexReport} from 'api/reportApi'
import {getAdConfig} from 'api/systemApi'
import {mapActions,mapGetters} from 'vuex'
export default {
    name: 'ReportIndex',
    // metaInfo: {
    //   title: '资鲸投研', // set a title
    //   meta: [{                 // set meta
    //     name: 'keyWords',
    //     content: '关键字内容'
    //   }],
    //   link: [{                 // set link
    //     rel: 'asstes',
    //     href: 'https://aaaaaaaaaaa/'
    //   }]
    // },
    data() {
        return {
            bgDownData: [{name: '新零售', code: '17', code2: '1701', img: require('@/common/images/report/index/icon-down_1.png')},
            {name: '金融', code: '01', code2: '0101', img: require('@/common/images/report/index/icon-down_2.png')},
            {name: '商业管理', code: '25', code2: '', img: require('@/common/images/report/index/icon-down_3.png')},
            {name: '在线教育', code: '08', code2: '0803', img: require('@/common/images/report/index/icon-down_4.png')},
            {name: '文化娱乐', code: '12', code2: '1203', img: require('@/common/images/report/index/icon-down_5.png')}], // 报告下载
            everyonelikelist: [], // 大家都爱看
            freereportlist: [], // 免费报告
            hotreportlist: [],  // 热门推荐
            limitedtimelist: [],    // 限时折扣
            newreportlist: [],  // 最新报告
            sellwelllist: [], // 畅销榜单
            advertisement1: [], // 广告1
            advertisement2: []  // 广告2
        }
    },
    mounted() {
        // 获取报告首页
        this.getIndexReportList(1)

        // // 获取广告
        this.getAdvertisement("N06", (data)=> {
            this.advertisement1 = data[0]
        })

        this.getAdvertisement("N07", (data)=> {
            this.advertisement2 = data[0]
        })
    },
    //判断pc或者移动，然后路由跳转
    created() {
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MRHome'
            })
        }
    },
    methods: {
        getIndexReportList(page, json) {    // 获取首页列表接口 同时也用于 最新报告 子组件内部调用
            this.setLoading(true)
            getIndexReport({
                data: {
                    industrycode2: json?json.industrycode2:"",
                    feetype: json?json.feetype:"",
                    datetime: json?json.datetime:"",
                    page: page,
                    pageSize: 10
                },
                success: data => {
                    this.setLoading(false)
                    console.log(data)

                    if (json) {
                        this.newreportlist = data.data.newreportlist  // 最新报告
                    } else {
                        this.everyonelikelist = data.data.everyonelikelist // 大家都爱看
                        this.freereportlist = data.data.freereportlist // 免费报告
                        this.hotreportlist = data.data.hotreportlist  // 热门推荐
                        this.limitedtimelist = data.data.limitedtimelist   // 限时折扣
                        this.newreportlist = data.data.newreportlist  // 最新报告
                        this.sellwelllist = data.data.sellwelllist // 畅销榜单

                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        routerDetails(innerid) {    // 用于组件跳转至报告详情页面
            const {href} = this.$router.resolve({
                name: 'ReportDetails', query: {'reportid': innerid}
            })
            window.open(href,'_blank')
        },
        routerSearch(code, typeData) {    // 用于组件跳转至搜索页面
            this.$router.push({
                name: 'ReportSearch',
                query: {
                    catecode: code,
                    typeData: typeData
                }
            })
        },
        getAdvertisement(code, request) {
            // 取得广告接口
            getAdConfig({
                data: {adcode: code},
                success: data=> {
                this.setLoading(false)
                    request(data.data.content)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        routeAdvertisement(href) {  // 广告跳转
            window.open(href, '_blank')
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['domainInfo'])
    },
    components: {
        Banner,
        NewBg,
        BestSellerList,
        PanicBuying,
        Recommend,
        Love
    }
}
</script>
<style lang="scss" scoped>
.ReportIndex {
    .bg-down {
        // margin-top: 30px;
        overflow: hidden;
        .content {
            div {
                float: left;
                margin: 15px 0;
                width: calc(100% / 5);
                img {
                    margin: 10px auto;
                    width: 58px;
                    height: 58px;
                }
                p {
                    font-size:14px;
                    margin-top: 8px;
                    text-align: center;
                }
                img,p {
                    cursor: pointer;
                }
                img:hover + p,
                p:hover {
                    color: #409EFF
                }
                // &:hover {
                //     p {
                //         color: 409EFF
                //     }
                // }
            }
        }
    }
    .advertisement {
        margin-top: 30px;
        width: 100%;
        height: 110px;
        cursor: pointer;
        img {
            width: 100%;
            height: 110px;
        }
    }
}
</style>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .ReportIndex {
        font-family:PingFangSC-Regular,PingFang SC;
        // min-height: 100vh;
    }
    .index-head {
        margin-top: 30px;
        overflow: hidden;
        p {
            float: left;
            &.name {
                position: relative;
                padding-left: 22px;
                font-size: 22px;
                color: #333;
                &::after {
                    content: '';
                    position: absolute;
                    display: block;
                    margin: auto;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 6px;
                    height: 6px;
                    background: #fff;
                    border-radius: 50%;
                    border: solid 4px #409EFF;
                }
            }
            
            &.more,
            &.msg {
                &,
                span {
                    color: #999999;
                    font-size: 14px;
                    line-height: 30px;
                }
                span {
                    cursor: pointer;
                    &:hover {
                        color: #409EFF;
                    }
                }

                &,
                span~span {
                    margin-left: 20px;
                }
                // color: #999999;
                // font-size: 14px;
            }
            &.more {
                float: right;
                cursor: pointer;
                line-height: 30px;
                &:hover {
                        color: #409EFF;
                    }
            }
        }
    }
    
</style>